/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GcpDeploymentImageConfig { 
    irr_image_name: string;
    cdvx_image_name: string;
    cloudrun_job_container_image_name: string;
}

